import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useCallback, useState, useEffect } from 'react';
import useResize from './useResize';
export default function useDimensions(ref) {
  var _useState = useState({
    containerWidth: 0,
    contentWidth: 0,
    scrollAmount: 0,
    scrollOffset: 0
  }),
      _useState2 = _slicedToArray(_useState, 2),
      dimensions = _useState2[0],
      setDimensions = _useState2[1]; // Updates all dimensions


  var updateDimensions = useCallback(function () {
    var el = ref.current;

    if (el) {
      setDimensions({
        containerWidth: el.clientWidth,
        contentWidth: el.scrollWidth,
        scrollAmount: el.scrollLeft,
        scrollOffset: el.offsetLeft
      });
    }
  }, [ref]); // Updates the provided dimension properties, leaving the rest intact

  var extendDimensions = useCallback(function (extension) {
    setDimensions(_objectSpread({
      containerWidth: dimensions.containerWidth,
      contentWidth: dimensions.contentWidth,
      scrollAmount: dimensions.scrollAmount,
      scrollOffset: dimensions.scrollOffset
    }, extension));
  }, [dimensions.containerWidth, dimensions.contentWidth, dimensions.scrollAmount, dimensions.scrollOffset]); // Updates only the scroll amount

  var handleScroll = useCallback(function () {
    extendDimensions({
      scrollAmount: ref.current.scrollLeft
    });
  }, [extendDimensions, ref]); // When the element resizes, update the dimensions

  useResize(ref, updateDimensions); // Initialize the dimensions after the first render

  useEffect(function () {
    updateDimensions();
  }, [updateDimensions]); // Update the scroll amount if the user has scrolled

  useEffect(function () {
    var el = ref.current;

    if (el) {
      el.addEventListener('scroll', handleScroll);
      return function () {
        el.removeEventListener('scroll', handleScroll);
      };
    }

    return undefined;
  }, [handleScroll, ref]);
  return [dimensions, extendDimensions];
}